export default "__VITE_ASSET__DkEWie7m__"